// Memory instruction handlers

export { mcopy } from "./0x5e_MCOPY.js";
export { mload } from "./0x51_MLOAD.js";
export { mstore } from "./0x52_MSTORE.js";
export { mstore8 } from "./0x53_MSTORE8.js";
